import {
    GET_ACTIVE_ASSET_COST_CENTER_DROP_DOWN,
    SET_ACTIVE_ASSET_COST_CENTER_DROP_DOWN,
    GET_ACTIVE_ASSET_MAKE_DROP_DOWN,
    SET_ACTIVE_ASSET_MAKE_DROP_DOWN,
    GET_ACTIVE_ASSET_MODEL_DROP_DOWN,
    SET_ACTIVE_ASSET_MODEL_DROP_DOWN,
    GET_ACTIVE_ASSET_YEAR_DROP_DOWN,
    SET_ACTIVE_ASSET_YEAR_DROP_DOWN,
    GET_ACTIVE_ASSET_GL_CATEGORY_DROP_DOWN,
    SET_ACTIVE_ASSET_GL_CATEGORY_DROP_DOWN,
    GET_ACTIVE_ASSET_EQ_CLASS_CODE_DROP_DOWN,
    SET_ACTIVE_ASSET_EQ_CLASS_CODE_DROP_DOWN,
    GET_ACTIVE_ASSET_STATE_DROP_DOWN,
    SET_ACTIVE_ASSET_STATE_DROP_DOWN,
    GET_ACTIVE_ASSET_ASSET_CATEGORY_DROP_DOWN,
    SET_ACTIVE_ASSET_ASSET_CATEGORY_DROP_DOWN
} from "./ActiveAssetDropDownType"

const getActiveAssetCostCenterDropDown = () => ({
    type: GET_ACTIVE_ASSET_COST_CENTER_DROP_DOWN
});
const setActiveAssetCostCenterDropDown = (activeAssetCostCenterDropDown: any) => ({
    type: SET_ACTIVE_ASSET_COST_CENTER_DROP_DOWN,
    activeAssetCostCenterDropDown
})

const getActiveAssetMakeDropDown = () => ({
    type: GET_ACTIVE_ASSET_MAKE_DROP_DOWN
});

const setActiveAssetMakeDropDown = (activeAssetMakeDropDown: any) => ({
    type: SET_ACTIVE_ASSET_MAKE_DROP_DOWN,
    activeAssetMakeDropDown
})

const getActiveAssetModelDropDown = () => ({
    type: GET_ACTIVE_ASSET_MODEL_DROP_DOWN
});

const setActiveAssetModelDropDown = (activeAssetModelDropDown: any) => ({
    type: SET_ACTIVE_ASSET_MODEL_DROP_DOWN,
    activeAssetModelDropDown
})

const getActiveAssetYearDropDown = () => ({
    type: GET_ACTIVE_ASSET_YEAR_DROP_DOWN
});

const setActiveAssetYearDropDown = (activeAssetYearDropDown: any) => ({
    type: SET_ACTIVE_ASSET_YEAR_DROP_DOWN,
    activeAssetYearDropDown
})

const getActiveAssetGLCategoryDropDown = () => ({
    type: GET_ACTIVE_ASSET_GL_CATEGORY_DROP_DOWN
});

const setActiveAssetGLCategoryDropDown = (activeAssetGLCategoryDropDown: any) => ({
    type: SET_ACTIVE_ASSET_GL_CATEGORY_DROP_DOWN,
    activeAssetGLCategoryDropDown
})

const getActiveAssetAssetCategoryDropDown = () => ({
    type: GET_ACTIVE_ASSET_ASSET_CATEGORY_DROP_DOWN
});

const setActiveAssetAssetCategoryDropDown = (activeAssetAssetCategoryDropDown: any) => ({
    type: SET_ACTIVE_ASSET_ASSET_CATEGORY_DROP_DOWN,
    activeAssetAssetCategoryDropDown
})

const getActiveAssetEqClassCodeDropDown = () => ({
    type: GET_ACTIVE_ASSET_EQ_CLASS_CODE_DROP_DOWN
});

const setActiveAssetEqClassCodeDropDown = (activeAssetEqClassCodeDropDown: any) => ({
    type: SET_ACTIVE_ASSET_EQ_CLASS_CODE_DROP_DOWN,
    activeAssetEqClassCodeDropDown
})

const getActiveAssetStateDropDown = () => ({
    type: GET_ACTIVE_ASSET_STATE_DROP_DOWN
});

const setActiveAssetStateDropDown = (activeAssetStateDropDown: any) => ({
    type: SET_ACTIVE_ASSET_STATE_DROP_DOWN,
    activeAssetStateDropDown
})
export {
    getActiveAssetCostCenterDropDown,
    setActiveAssetCostCenterDropDown,
    getActiveAssetMakeDropDown,
    setActiveAssetMakeDropDown,
    getActiveAssetModelDropDown,
    setActiveAssetModelDropDown,
    getActiveAssetYearDropDown,
    setActiveAssetYearDropDown,
    getActiveAssetGLCategoryDropDown,
    setActiveAssetGLCategoryDropDown,
    getActiveAssetAssetCategoryDropDown,
    setActiveAssetAssetCategoryDropDown,
    getActiveAssetEqClassCodeDropDown,
    setActiveAssetEqClassCodeDropDown,
    getActiveAssetStateDropDown,
    setActiveAssetStateDropDown
}